import { useContext } from 'react';
import AppContext from 'flow/contexts/app-context';

const useAppContext = () => {
    const context = useContext(AppContext);

    if (!context) {
        throw new Error(
            'useAppContext must be used within an AppContext provider',
        );
    }

    return context;
};

export default useAppContext;
